import { Box, Grid } from '@mui/material';
import CustomAccordion from '../../../../components/Accordion/CustomAccordion';
import useResponsibles from './hooks/useResponsibles';
import useContractors from './hooks/useContractors';
import { ResponsiblesAccordionContent } from './components/ResponsiblesAccordionContent';
import { ContractorsAccordionContent } from './components/ContractorsAccordionContent';
import useResponsiblesModule from './hooks/useResponsiblesModule';
import DrawerManager from './components/drawers';
import useAlerts from './hooks/useAlerts';
import BackdropComponent from '../../../../components/Backdrop/BackdropComponent';
import { CarcinogenicModuleFooter } from '../../components/CarcinogenicModuleFooter';
import useSendCarcinogenicReport from '../../hooks/useSendCarcinogenicReport';
import { useNavigate } from 'react-router-dom';
import { TEST_IDS } from './testIds';
import { TAB_INDEX } from '../../pages';

const ResponsiblePartiesAndContractorsTabContent = ({
    showCancelCarcinogenicReportAlert,
    IS_REPORT_READY_TO_PRESENT,
    handleTabChange,
    onlyVisual
}: any) => {
    const {
        selected,
        open,
        translate,
        setOpen,
        handleEditNewContractorIconClick,
        handleEditContractorIconClick,
        handleNewResponsibleIconClick,
        handleEditResponsibleIconClick
    } = useResponsiblesModule();

    const alerts = useAlerts({ translate: translate });

    const contractorsState = useContractors();
    const responsiblesState = useResponsibles();
    const { handleSendCarcinogenicReportClickButtonClick } = useSendCarcinogenicReport({
        isReadyToPresent: IS_REPORT_READY_TO_PRESENT
    });

    const { contractors, isDeletingContractor, isAddingContractor, isEditingContractor } =
        contractorsState;
    const { responsibles, isDeletingResponsible, isAddingResponsible, isEditingResponsible } =
        responsiblesState;

    const navigate = useNavigate();

    const handleFooterCancelClick = () => {
        if (onlyVisual) {
            handleTabChange(TAB_INDEX.WORKERS_AND_MEDICAL_EXAMS);
            return;
        };
        showCancelCarcinogenicReportAlert({ confirmAction: () => navigate(-1) });
    };

    return (
        <>
            <Box
                component="div"
                justifyContent="center"
                bgcolor={'#ffffff'}
                borderRadius={'0px 0px 6px 6px'}
                p={3}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <CustomAccordion
                            testID={TEST_IDS.contractors.accordion}
                            seccion={{
                                id: 1,
                                titulo: translate('accordions.contractors.title'),
                                descripcion: translate('accordions.contractors.subtitle')
                            }}
                            rightButtonText={translate('accordions.contractors.button')}
                            initiallyExpanded={true}
                            rightButton={!onlyVisual}
                            onRightButtonClick={handleEditNewContractorIconClick}
                            required
                            Children={
                                <ContractorsAccordionContent
                                    translate={translate}
                                    handleClickEditIcon={handleEditContractorIconClick}
                                    contractors={contractors}
                                    contractorsState={contractorsState}
                                    alerts={alerts}
                                    onlyVisual={onlyVisual}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomAccordion
                            testID={TEST_IDS.responsibles.accordion}
                            seccion={{
                                id: 2,
                                titulo: translate('accordions.responsibles.title'),
                                descripcion: translate('accordions.responsibles.subtitle')
                            }}
                            rightButtonText={translate('accordions.responsibles.button')}
                            initiallyExpanded={true}
                            rightButton={!onlyVisual}
                            onRightButtonClick={handleNewResponsibleIconClick}
                            required
                            Children={
                                <ResponsiblesAccordionContent
                                    translate={translate}
                                    responsiblesState={responsiblesState}
                                    responsibles={responsibles}
                                    handleClickEditIcon={handleEditResponsibleIconClick}
                                    alerts={alerts}
                                    onlyVisual={onlyVisual}
                                />
                            }
                        />
                    </Grid>
                </Grid>
                <DrawerManager
                    open={open}
                    setOpen={setOpen}
                    selected={selected}
                    responsiblesState={responsiblesState}
                    contractorsState={contractorsState}
                    onlyVisual={onlyVisual}
                />
                <BackdropComponent
                    loading={
                        isDeletingContractor ||
                        isAddingContractor ||
                        isEditingContractor ||
                        isDeletingResponsible ||
                        isAddingResponsible ||
                        isEditingResponsible
                    }
                />
            </Box>
            <CarcinogenicModuleFooter
                handleCancelClick={handleFooterCancelClick}
                handleSubmitClick={() => {
                    if (onlyVisual) return;
                    handleSendCarcinogenicReportClickButtonClick();
                }}
                onlyVisual={onlyVisual}
                disableNextButton={onlyVisual}
                lastPage
            />
        </>
    );
};

export { ResponsiblePartiesAndContractorsTabContent };
